export const ASSET_IMAGES = process.env.REACT_APP_IMAGES_PATH;
export const ASSET_AVATARS = ASSET_IMAGES + "/avatar";
export const ASSET_LOGOS = ASSET_IMAGES + "/logos";
export const ASSET_CODINGPAL = `${ASSET_IMAGES}/codingpal`;
export const ASSET_PROGRAMMING_LANGUAGES = `${ASSET_IMAGES}/codingpal/programming-languages`;

export const USE_IMAGE_PLACEHOLDERS = false;

export const USER_ACCOUNT = "/services/semstarauthentication/api/account";

export const USER_LOGIN = "/auth/login";

export const USER_SIGNUP = "services/semstarauthentication/api/register";

export const USER_RESET_PASSWORD =
  "services/semstarauthentication/api/account/reset-password/init";

export const PRICING_PLANS = "services/semstarauthentication/api/plans";

export const PREMIUM_PLANS = "services/semstarauthentication/api/premium-plans";

export const PREMIUM_PLAN_PURCHASE_DETAILS =
  "services/semstarauthentication/api/premium-plan-purchase-details";

export const GET_TAGS_PATH =
  "/services/semstarauthentication/api/aand-ds-problem-tags/unique";

export const GET_PROBLEMS_FOR_NAVIGATION =
  "/services/semstarauthentication/api/problems/for-navigation";

export const GET_PROBLEMS_BY_ID =
  "/services/semstarauthentication/api/problems";

export const GET_PROBLEM_DETAILS_NEW =
  "/services/semstarauthentication/api/problems/by-name";

export const GET_PROBLEM_METADATA =
  "/services/semstarauthentication/api/problems/metadata";

export const EVALUATE_CODE =
  "/services/semstarauthentication/api/user-problem-submissions/evaluate-code";

export const GET_USER_PROBLEM_SUBMISSION_DETAILS =
  "/services/semstarauthentication/api/user-problem-submissions";

export const GET_USER_PROBLEM_SUBMISSION_RESULT_DETAILS =
  "/services/semstarauthentication/api/user-problem-submissions/submission-result";

export const GET_PROGRAMMING_CONTENTS =
  "/services/semstarauthentication/api/programming-contents";

export const GET_PROGRAMMING_CONTENT_BY_URL =
  "/services/semstarauthentication/api/programming-contents/content";

export const GET_PROGRAMMING_CONTENTS_MENU =
  "services/semstarauthentication/api/programming-contents/menu";

export const PROGRAMMING_CONTENT_EXECUTE_CODE =
  "services/semstarauthentication/api/user-problem-submissions/execute-for-programming-content";

export const GET_PROGRAMMING_CONTENT_SUBMISSION_RESULT =
  "services/semstarauthentication/api/user-problem-submissions/submission-result-for-programming-content";

export const ADMIN_USERS = "services/semstarauthentication/api/users";

export const ADMIN_USER_BY_ID =
  "services/semstarauthentication/api/users/by-id";

export const ADMIN_REPORTS = "services/semstarauthentication/api/reports";

export const ADMIN_USER_PLANS = "services/semstarauthentication/api/user-plans";

export const REPORT_A_ISSUE = "services/semstarauthentication/api/reports/mine";

export const GET_VIDEO_URL =
  "services/semstarauthentication/api/problems/videos";

export const TAGS = "services/semstarauthentication/api/tags";

export const GET_TAGS =
  "services/semstarauthentication/api/tags/for-navigation";

export const ADMIN_USER_STREAKS =
  "services/semstarauthentication/api/user-streaks";
